module.exports = __webpack_public_path__ + "media/images/ohap_calendar-b0d6e8c48c2fdee117b7282e6031b467.png";